import axiosApiInstance from "../../interceptors/axiosApiInstance";
import { BASE_URL } from "../config";

const AutomService = {
    getAllAutoms: async function (filter = "", installed = '', groupId = "", startIndex, itemsPerPage, searchValue) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs?type_id=${filter}&installed=${installed}&autom_group_id=${groupId}`, {
                params: {
                    startIndex,
                    itemsPerPage,
                    searchValue
                }
            }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomsCountByFilter: async function () {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/count/installed/filter`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomsByFilter: async function (filter) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/filter?input_data=${filter}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkItExist: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/check/${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomsById: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/getbyid/${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCallAutomList: async function (autom_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/automs/${autom_id}/call/list`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    callAutomDetail: async function (autom_version_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/automs/call/detail`, { params: { autom_version_id } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteAutoms: async function (data) {
        try {
            const response = await axiosApiInstance.delete(await BASE_URL + "/automs", {
                data: {
                    id: data,
                },
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postAutom: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + "/automs", data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateAutom: async function (data, id) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/automs`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    changeStatus: async function (data, id) {
        try {
            const response = await axiosApiInstance.put(
                await BASE_URL + `/automs/status/${id}`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    runAutom: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/running`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    runAction: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + "/automs/run-action",
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getListType: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + "/automs/type");
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postPublish: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + "/automs/publish",
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description this function sends request to download an autom
     * @Param       data - { "bot_id" : "1bedf214-d6a3-4eb9-8c84-349c1a5b672f" }
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    downloadAutom: async function (bot_id, bv_id) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + "/automs/download",
                { bot_id, bv_id }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Active Autom Count
     * @Param       startDate="", endDate=""
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getAutomCount: async function (startDate = "", endDate = "") {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/count?startDate=${startDate}&endDate=${endDate}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Disabling Automs
     * @Param       data = { status: 0 || 1, ids: [ "ids" ]}
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    changeAutomsStatus: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + "/automs/change-status",
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    cancelAutom: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + "/automs/cancel",
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    stopAction: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + "/automs/shutdown/action-sessions",
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Create autom operation Services
     * @Param       automId
     * @Returns     response
     * @Author      Kerem Karadeniz
     */
    generateOperation: async function (automId, mateId, isDebugging = false) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + "/automs/operation/generate",
                {
                    automId,
                    mateId,
                    isDebugging,
                }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    debuggingAutom: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/debugging`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    // getting autom version
    getAutomVersion: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/version?autom_id=${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    // getting autom  and flow and diagram
    getByAutomVersion: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/version/getbyid?id=${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    // upgrade autom flow
    upgradeAutomFlow: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/version/upgrade`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    automStart: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/start`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    automProfile: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/profile`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    automStop: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/stop`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getByAutomProfile: async function (autom_id, type) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/profile?autom_id=${autom_id}&type=${type}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkIsRunningStatus: async function (autom_id, type) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/checkIsRunning?autom_id=${autom_id}&type=${type}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomNameList: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/automs/list`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getNextRunTimesOfSchedulers: async function (qpool_id = null, startIndex = null, itemsPerPage = null, searchValue = null) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/automs/scheduler`, {
                params: {
                    qpool_id: qpool_id,
                    startIndex,
                    itemsPerPage,
                    searchValue
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    setActiveVersion: async function (data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/automs/version/activate`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Exporting flow
     * @Param       data = flow json
     * @Returns     response or error
     * @Author      Onur DOGUCU
     */
    exportFlow: async function (data, id) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/export`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Exporting flow
     * @Param       data = flow json
     * @Returns     response or error
     * @Author      Onur DOGUCU
     */
    importFlow: async function (file, versionId, automType = "Autom", check_it, libraryControl = false) {
        try {
            let formData = new FormData();

            formData.append('v_id', versionId);
            formData.append('file', file);
            formData.append('autom_type', automType);
            formData.append('check_it', check_it);
            formData.append('libraryControl', libraryControl);
            const response = await axiosApiInstance.post(await BASE_URL + `/automs/${versionId}/import`, formData);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateTrigger: async function (data, id) {
        try {
            const response = await axiosApiInstance.put(
                await BASE_URL + `/automs/${id}/trigger`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getClickedArea: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/gca`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomGroups: async function () {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/groups`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomDetail: async function (id) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/detail/${id}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    createAutomGroup: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/automs/group`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateAutomGroup: async function (groupId, data) {
        try {
            const response = await axiosApiInstance.put(
                await BASE_URL + `/automs/group/${groupId}`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteAutomGroup: async function (data) {
        try {
            const response = await axiosApiInstance.delete(
                await BASE_URL + `/automs/group`,
                {
                    data: {
                        ids: data
                    }
                }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    showFlowsInDeletedGroup: async function (groupId) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/group/${groupId}/check`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getQueuePoolsByScheduler: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/automs/scheduler/queue/pools`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    addFlowInsideAutomGroup: async function (groupId, data) {
        try {
            const response = await axiosApiInstance.put(
                await BASE_URL + `/automs/group/${groupId}/assign`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getMonitoringAutomsByStatus: async function (status, startIndex, itemsPerPage, searchValue) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/automs/getMonitoringAutoms`, {
                params: {
                    status,
                    startIndex,
                    itemsPerPage,
                    searchValue
                }
            }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },

};
export default AutomService;
